var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{attrs:{"id":"uploader"}},[_vm._t("default",[_c('span',[_vm._v("修改头像")])]),_vm._v(" "),_c('input',{staticClass:"weui-uploader__input",attrs:{"type":"file","accept":"image/*","multiple":""},on:{"click":_vm.clickUpload}})],2)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-11ce6bb1","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/coach/Uploader.vue
// module id = null
// module chunks = 